import { Injectable, Signal } from "@angular/core";
import { Store } from "@ngrx/store";
import { ShippingState } from "../../../store/shipping/shipping.reducer";
import { BalanceModel } from "../../../features/perfil-user/store/balance.model";
import { toSignal } from '@angular/core/rxjs-interop';
import { ResumenPedidoService } from "../../../features/detail-orden-checkout/components/resumen-pedido/service/resumen-pedido.service";
import { CartService } from "../cart-apis/cart.service";
@Injectable({ providedIn: 'root' })

export class CalculateTotalService {

  totalCost: Signal<any>;
  shippingCost: Signal<any>;
  deliveryTip: Signal<any>;
  cartTotal: Signal<number>;
  tarifaBase: Signal<any>;
  tarifaServicio: Signal<any>;
  mountForDelivery: number = 0;

  balance: Signal<string | undefined>;
  constructor(private store: Store<{ shipping: ShippingState, balance: BalanceModel }>, private resumenPedidoService: ResumenPedidoService, private cartService: CartService) {
    this.balance = toSignal(this.store.select(state => state.balance.balance));
    this.totalCost = toSignal(this.store.select(state => state.shipping.totalCost));
    this.shippingCost = toSignal(this.store.select(state => state.shipping.shippingCost));
    this.deliveryTip = toSignal(this.store.select(state => state.shipping.deliveryTip));
    this.tarifaBase = toSignal(this.store.select(state => state.shipping.tarifaBase));
    this.tarifaServicio = toSignal(this.store.select(state => state.shipping.tarifaServicio));
    // Convert cart total to signal to avoid repeated subscriptions
    this.cartTotal = toSignal(this.cartService.getTotalPurchase(), { initialValue: 0 });
  }

  calculateWithoutBalance(): number {
    // Use signals to get current values efficiently
    const cartTotal = this.cartTotal() || 0;
    const shipping = Number(this.shippingCost()) || 0;
    // Leer propina desde el store (signal) para reactividad confiable
    const tip = Number(this.deliveryTip()) || 0;
    const tarifaBase = Number(this.tarifaBase()) || 0;
    const tarifaServicio = Number(this.tarifaServicio()) || 0;

    // Calculate the sum and format to 2 decimal places
    const sum = cartTotal + shipping + tip + tarifaBase + tarifaServicio;

    // Return as a number (not a string)
    return parseFloat(sum.toFixed(2));
  }

}
